<template>

</template>

<script>
    import VisCommon from '../components/VisCommon'
    import Modal from './Modal'

    const REPORTS_API = '/report/csv/win/campaign'
    const PHONEBASEUPLOADING_API = '/outgoing-cpg-sec'
    const CAMPAIGNS_CTS_API = '/outgoing-cpg-sec'
    const OLD_REPORTS_API = '/calls'

    export default {
        name: 'CampaignsCommon',
        extends: VisCommon,
        components: {
          Modal
        },
        data () {
            return {
                permissionKey: 'campaign'
            }
        },
        methods: {
            getCampaignStateInfo(campaign) {
                if (this.canSetReadyStatus(campaign)) {
                    return 'Готова к запуску'
                } else if (this.canPauseStatus(campaign)) {
                    return 'Запущена'
                } else {
                    return campaign.state
                }
            },
            getCampaignStateInfoTrans(campaign) {
              let state = this.getCampaignStateInfo(campaign)
              if (state === 'Готова к запуску') {
                return 'campaigns.states.readyToRun'
              } else if (state === 'Запущена') {
                return 'campaigns.states.started'
              } else {
                return (campaign.stateCode ? ('campaigns.states.' + campaign.stateCode.toLowerCase()) : state)
              }
            },
            canSetReadyStatus(campaign) {
                let result = ((campaign.state === 'В разработке' || (campaign.scheduleStrategy && campaign.scheduleStrategy.startsWith('DAILY_TIME_INTERVAL') && campaign.state !== 'Подготовлена' && campaign.state !== 'Прозвон идёт') || this.canContinue(campaign)) &&
                    this.canModerate(this.permissionKey) && campaign.client != null &&
                    campaign.date != null && campaign.scenario != null && campaign.zoneOffset != null &&
                    campaign.timeStart != null && campaign.timeEnd
                )
                return result
            },
            canPauseStatus(campaign) {
                let result = (campaign.scheduleStrategy && campaign.scheduleStrategy.startsWith('DAILY_TIME_INTERVAL') && (campaign.state === 'Подготовлена' || campaign.state === 'Прозвон идёт') && this.canModerate(this.permissionKey))
                return result
            },
            canContinue(campaign) {
                return campaign.state === 'Завершена' && campaign.hasReadyTasks
            },
            setReadyStatus (campaign) {
                campaign.state = 'Подготовлена'
                this.$http.put(CAMPAIGNS_CTS_API + '/' + campaign.id + '/updatestate?state=READY', {}, {headers: this.prepareSecurityHeader()})
                    .then(() => {
                        this.openNotificationWithType('info', 'Рассылка готова к запуску.')
                    })
                    .catch((error) => {
                        console.log(error)
                        this.openNotificationWithType('danger', 'Ошибка запуска рассылки. ')
                    })
            },
            setPauseStatus (campaign) {
                campaign.state = 'Остановлена'
                this.$http.put(CAMPAIGNS_CTS_API + '/' + campaign.id + '/updatestate?state=PAUSED_INTENTIONALLY', {}, {headers: this.prepareSecurityHeader()})
                    .then(() => {
                        this.openNotificationWithType('info', 'Рассылка остановлена')
                    })
                    .catch((error) => {
                        console.log(error)
                        this.openNotificationWithType('danger', 'Ошибка остановки рассылки. ')
                    })
            },
            canLoadReport(campaign) {
                return campaign.state === 'Завершена' || campaign.scheduleStrategy === 'DAILY_TIME_INTERVAL'
            },
            getReportCSV (campaign, periodStart, periodEnd) {
              if (typeof periodStart === 'undefined') {
                periodStart = ''
              }
              if (typeof periodEnd === 'undefined') {
                periodEnd = ''
              }
              let timezone = (campaign.zoneOffset || '+7').replace('+', '%2B')
              let url
              if (periodEnd && periodStart) {
                url = `${REPORTS_API}/${campaign.id}?reportMode=full&timeZone=${timezone}&start=${periodStart}&end=${periodEnd}`
              } else {
                url = `${OLD_REPORTS_API}/id/${campaign.id}/win/csv?audioPath=${campaign.recordHost + '/' + campaign.clientId + '/' + campaign.id}`
              }
              this.$http.get(url, {headers: this.prepareSecurityHeader(), timeout: 180000})
                    .then((response) => {
                        let s = response.headers['content-disposition']
                        let res = s.split('filename="').pop()
                        res = res.split('"')[0]
                        let blob = new Blob([response.data], { type: 'text/csv' })
                        let a = window.document.createElement('a')
                        a.href = window.URL.createObjectURL(blob)
                        a.download = res
                        document.body.appendChild(a)
                        a.click()
                        document.body.removeChild(a)
                    })
                    .catch((error) => {
                        this.openNotificationWithType('danger', 'Ошибка загрузки отчета')
                        console.log(error)
                    })
            },
            uploadPhones(inputId, campaign) {
                const input = document.querySelector(`#${inputId}`)
                if (input.files && input.files[0]) {
                    if (!campaign.id) {
                        this.openNotificationWithType('danger', 'Перед загрузкой базы необходимо сохранить рассылку')
                    } else {
                        this.handleUploadPhonesRequest(input.files[0], campaign)
                    }
                }
            },
            handleUploadPhonesRequest (phonesFile, campaign) {
                this.$http.post(PHONEBASEUPLOADING_API + '/' + 'loadForCampaign', this.prepareMultipartFile(phonesFile, campaign.id),
                    {headers: this.prepareSecurityHeader(), timeout: 180000})
                    .then(response => {
                        if (response.status === 200) {
                            let message = ''
                            if (typeof response.data === 'string' || response.data instanceof String) {
                                message = response.data
                            } else if (response.data && !response.data.message) {
                                message = response.data.message
                            }
                            if (!message) {
                                this.openNotificationWithType('info', 'База загружена.')
                            } else {
                                this.openNotificationWithType('danger', message, 0)
                            }
                            // this.loadTasksCount(campaign)
                            // this.loadTasksCountPerformed(campaign)
                        } else {
                            this.openNotificationWithType('danger', 'Ошибка загрузки файла')
                        }
                    })
                    .catch(error => {
                        this.openNotificationWithType('danger', 'Ошибка загрузки файла')
                        console.log(error)
                    })
            },
            // loadTasksCount (campaign) {
            //     this.$http.get(CALLTASKS_API + '/' + campaign.id + '/count', {headers: this.prepareSecurityHeader()})
            //         .then((response) => {
            //             campaign.tasksCount = response.data
            //         })
            //         .catch((error) => {
            //             console.log(error)
            //         })
            // },
            // loadTasksCountPerformed (campaign) {
            //     this.$http.get(CALLTASKS_API + '/' + campaign.id + '/countPerformed', {headers: this.prepareSecurityHeader()})
            //         .then((response) => {
            //             campaign.tasksCountPerformed = response.data
            //         })
            //         .catch((error) => {
            //             console.log(error)
            //         })
            // },
            prepareMultipartFile (phonesFile, phonesCampaign) {
                const phonesFormData = new FormData()
                phonesFormData.append('file', phonesFile)
                phonesFormData.append('campaign', phonesCampaign)
                return phonesFormData
            },
            uploadFile(buttonId) {
                document.getElementById(buttonId).click()
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CampaignsCommon.vue?6c004558